module.exports = __webpack_public_path__ + "static/media/MyHDStory_2.6b716722.png";